export const attach = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M9.64978 15.5171L15.3125 9.71875"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6667 5.12503L5.53146 11.3857C5.25807 11.6591 5.10448 12.03 5.10448 12.4167C5.10448 12.8034 5.25807 13.1743 5.53146 13.4477C5.80494 13.7211 6.17581 13.8747 6.5625 13.8747C6.9492 13.8747 7.32007 13.7211 7.59355 13.4477L13.7288 7.18711C14.2755 6.64016 14.5827 5.89842 14.5827 5.12503C14.5827 4.35163 14.2755 3.6099 13.7288 3.06294C13.1818 2.51615 12.4401 2.20898 11.6667 2.20898C10.8933 2.20898 10.1515 2.51615 9.60459 3.06294L3.46865 9.32284C2.64811 10.1434 2.18713 11.2563 2.18713 12.4167C2.18713 13.5771 2.64811 14.69 3.46865 15.5105C4.28919 16.3311 5.40208 16.7921 6.5625 16.7921C7.72293 16.7921 8.83582 16.3311 9.65636 15.5105"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const sendmessage = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M11.0992 16.5627C11.1269 16.6318 11.175 16.6907 11.2372 16.7316C11.2993 16.7725 11.3725 16.7933 11.4469 16.7914C11.5212 16.7895 11.5932 16.7649 11.6532 16.7209C11.7132 16.6769 11.7583 16.6156 11.7824 16.5452L16.522 2.69107C16.5453 2.62646 16.5498 2.55654 16.5348 2.4895C16.5199 2.42245 16.4861 2.36105 16.4375 2.31247C16.389 2.2639 16.3276 2.23016 16.2605 2.21521C16.1935 2.20026 16.1236 2.20472 16.0589 2.22805L2.20478 6.96764C2.13441 6.99177 2.07311 7.03685 2.02911 7.09682C1.9851 7.1568 1.96049 7.2288 1.95859 7.30317C1.95668 7.37753 1.97757 7.4507 2.01845 7.51285C2.05933 7.575 2.11824 7.62316 2.18728 7.65086L7.96957 9.96961C8.15237 10.0428 8.31845 10.1522 8.4578 10.2913C8.59715 10.4304 8.70689 10.5963 8.78041 10.779L11.0992 16.5627Z"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.4352 2.31555L8.45813 10.2919"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const micicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M8.75 2.20837C8.16984 2.20837 7.61344 2.43884 7.2032 2.84908C6.79297 3.25931 6.5625 3.81571 6.5625 4.39587V9.50004C6.5625 10.0802 6.79297 10.6366 7.2032 11.0468C7.61344 11.4571 8.16984 11.6875 8.75 11.6875C9.33016 11.6875 9.88656 11.4571 10.2968 11.0468C10.707 10.6366 10.9375 10.0802 10.9375 9.50004V4.39587C10.9375 3.81571 10.707 3.25931 10.2968 2.84908C9.88656 2.43884 9.33016 2.20837 8.75 2.20837Z"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.8542 8.04163V9.49996C13.8542 10.8537 13.3164 12.1519 12.3592 13.1092C11.402 14.0664 10.1037 14.6041 8.75001 14.6041C7.3963 14.6041 6.09804 14.0664 5.14082 13.1092C4.1836 12.1519 3.64584 10.8537 3.64584 9.49996V8.04163"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.75 14.6041V16.7916"
      stroke="#1D2951"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const news = (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6562 24.1667H6.34374C5.34066 24.1668 4.37557 23.783 3.64646 23.0941C2.91735 22.4052 2.47949 21.4634 2.4227 20.462L2.41666 20.2396V7.55212C2.41657 6.86322 2.67801 6.19997 3.14814 5.69642C3.61828 5.19287 4.26204 4.88657 4.94932 4.83942L5.13541 4.83337H20.2396C20.9285 4.83329 21.5917 5.09473 22.0953 5.56486C22.5988 6.03499 22.9051 6.67875 22.9523 7.36604L22.9583 7.55212V8.45837H23.8646C24.5535 8.45829 25.2167 8.71973 25.7203 9.18986C26.2238 9.65999 26.5301 10.3038 26.5773 10.991L26.5833 11.1771V20.2396C26.5834 21.2427 26.1996 22.2078 25.5107 22.9369C24.8218 23.666 23.88 24.1039 22.8786 24.1607L22.6562 24.1667ZM6.34374 22.3542H22.6562C23.1871 22.3542 23.6986 22.1544 24.089 21.7947C24.4794 21.4349 24.7202 20.9415 24.7636 20.4124L24.7708 20.2396V11.1771C24.7708 10.9581 24.6915 10.7465 24.5476 10.5815C24.4036 10.4165 24.2048 10.3091 23.9878 10.2793L23.8646 10.2709H22.9583V19.6355C22.9583 19.8545 22.879 20.066 22.7351 20.2311C22.5911 20.3961 22.3923 20.5035 22.1753 20.5332L22.0521 20.5417C21.8331 20.5417 21.6215 20.4624 21.4564 20.3184C21.2914 20.1745 21.1841 19.9757 21.1543 19.7587L21.1458 19.6355V7.55212C21.1458 7.33313 21.0665 7.12154 20.9226 6.9565C20.7786 6.79146 20.5798 6.68412 20.3628 6.65433L20.2396 6.64587H5.13541C4.91641 6.64588 4.70483 6.72519 4.53978 6.86913C4.37474 7.01308 4.2674 7.21191 4.23761 7.42887L4.22916 7.55212V20.2396C4.22918 20.7703 4.42874 21.2816 4.78823 21.672C5.14772 22.0624 5.64085 22.3033 6.16974 22.347L6.34374 22.3542ZM14.7972 17.5209H18.4295C18.6591 17.5209 18.8801 17.6082 19.0479 17.7649C19.2157 17.9217 19.3177 18.1363 19.3334 18.3654C19.349 18.5944 19.2771 18.8209 19.1322 18.999C18.9873 19.1771 18.7802 19.2936 18.5527 19.3249L18.4295 19.3334H14.7972C14.5676 19.3333 14.3466 19.2461 14.1788 19.0893C14.011 18.9326 13.909 18.718 13.8934 18.4889C13.8777 18.2598 13.9496 18.0333 14.0945 17.8552C14.2394 17.6771 14.4465 17.5606 14.674 17.5293L14.7972 17.5209ZM11.1686 13.2977C11.409 13.2977 11.6395 13.3932 11.8094 13.5632C11.9794 13.7331 12.0749 13.9636 12.0749 14.204V18.4271C12.0749 18.6675 11.9794 18.898 11.8094 19.0679C11.6395 19.2379 11.409 19.3334 11.1686 19.3334H6.94549C6.70514 19.3334 6.47463 19.2379 6.30467 19.0679C6.13472 18.898 6.03924 18.6675 6.03924 18.4271V14.204C6.03924 13.9636 6.13472 13.7331 6.30467 13.5632C6.47463 13.3932 6.70514 13.2977 6.94549 13.2977H11.1686ZM10.2624 15.1102H7.85174V17.5209H10.2624V15.1102ZM14.7972 13.2977H18.4295C18.6591 13.2978 18.8801 13.385 19.0479 13.5418C19.2157 13.6986 19.3177 13.9132 19.3334 14.1422C19.349 14.3713 19.2771 14.5978 19.1322 14.7759C18.9873 14.954 18.7802 15.0705 18.5527 15.1018L18.4295 15.1102H14.7972C14.566 15.1126 14.3426 15.0265 14.1728 14.8695C14.003 14.7125 13.8996 14.4965 13.8839 14.2658C13.8681 14.0351 13.9412 13.807 14.0881 13.6284C14.235 13.4498 14.4446 13.3341 14.674 13.305L14.7972 13.2977ZM6.94549 9.06496H18.4295C18.6607 9.06261 18.8841 9.14875 19.0539 9.30574C19.2237 9.46274 19.3271 9.67871 19.3428 9.90943C19.3586 10.1402 19.2856 10.3682 19.1387 10.5468C18.9918 10.7254 18.7822 10.8411 18.5527 10.8702L18.4295 10.8775H6.94549C6.71588 10.8774 6.49485 10.7902 6.32708 10.6334C6.1593 10.4767 6.05728 10.2621 6.04163 10.033C6.02598 9.8039 6.09786 9.57742 6.24276 9.3993C6.38766 9.22119 6.59477 9.10471 6.82224 9.07342L6.94549 9.06496Z"
      fill="white"
    />
  </svg>
);

export const pin = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.9375 9.0625L1.875 13.125"
      stroke="#575860"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.125 5.92818L8.87063 11.6738L9.93125 10.6132L9.68563 8.24631L13.1294 5.32568L9.47312 1.66943L6.55187 5.11318L4.18563 4.86756L3.125 5.92818Z"
      fill="#575860"
      stroke="#575860"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
